import { useRef, useEffect } from 'react'
import { Animated, Easing } from 'react-native'

export const useSpinAnimation = (isSpinning: boolean, duration: number = 800) => {
    const rotation = useRef(new Animated.Value(0)).current

    useEffect(() => {
        if (isSpinning) {
            Animated.loop(
                Animated.timing(rotation, {
                    toValue: 1,
                    duration,
                    easing: Easing.linear,
                    useNativeDriver: true,
                })
            ).start()
        } else {
            rotation.stopAnimation()
            rotation.setValue(0)
        }
    }, [isSpinning, duration, rotation])

    const spin = rotation.interpolate({
        inputRange: [0, 1],
        outputRange: ['0deg', '360deg'],
    })

    return spin
}